import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Topmenuleft() {
  return (
    <nav class="navbar navbar-expand-lg">



      <button data-mdb-button-init class="navbar-toggler px-0" type="button" data-mdb-collapse-init
        data-mdb-target="#navbarExampleOnHover" aria-controls="navbarExampleOnHover" aria-expanded="false"
        aria-label="Toggle navigation">
      </button>

      <div class="collapse navbar-collapse" id="navbarExampleOnHover">

        <ul class="navbar-nav">
          <li class="nav-item first">
            <Link className='nav-link' to='/home'>Home</Link>
          </li>

          <li class="nav-item">
            <Link className='nav-link' to='/about'>About</Link>
          </li>

          <li class="nav-item dropdown dropdown-hover ">
            <a data-mdb-dropdown-init class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-mdb-toggle="dropdown" aria-expanded="false">
              Courses
            </a>
            <div class="dropdown-menu mt-0" aria-labelledby="navbarDropdown" >
              <ul>
                <li><Link className='order-history-link' to='/skill-education'>Skill Education</Link></li>
                <li><Link className='order-history-link' to='/traditional-education'>Traditional Education</Link></li>
              </ul>
            </div>
          </li>

          <li class="nav-item">
            <Link className='nav-link' to='/admission'>Admission</Link>
          </li>

          <li class="nav-item">
            <Link className='nav-link' to='/e-learning'>E-Learning</Link>
          </li>

          <li class="nav-item">
            <Link className='nav-link' to='/recognition'>Recognition</Link>
          </li>

           <li class="nav-item">
            <Link className='nav-link' to='/result'>Results</Link>
          </li>



          <li class="nav-item">
            <Link className='nav-link' to='/authorized-centers'>Authorized Centers</Link>
          </li>

          <li class="nav-item">
            <Link className='nav-link' to='/contact'>Contact</Link>
          </li>

          {/* 
             <li class="nav-item">
               <Link className='nav-link' to='/add-result'>Add Result</Link>
            </li>

            <li class="nav-item">
               <Link className='nav-link' to='/all-results'>All Results</Link>
            </li> */}

        </ul>

      </div>



    </nav>
  )

}

export default Topmenuleft;
